export default __webpack_public_path__ + "static/media/phone-bg.5e4fa1af.jpg";